/**
 * API Configuration for ARGUS Platform
 * Uses Django Backend Only
 */

// Environment detection
const isProduction = process.env.NODE_ENV === 'production';

// API URL Configuration for Microservices Architecture
// Auth Service (Port 8000) - for authentication only
const AUTH_API_URL = isProduction
  ? '/api'
  : (process.env.REACT_APP_API_URL || 'http://localhost:8000/api');

// Hermes Backend (Port 8001) - for business data
const HERMES_API_URL = isProduction
  ? '/api'
  : (process.env.REACT_APP_HERMES_API_URL || 'http://localhost:8001/api');

// Default to Hermes Backend for most requests
export const API_BASE_URL = HERMES_API_URL;
export const AUTH_BASE_URL = AUTH_API_URL;
export const useDjangoAPI = true;

// API Endpoints Configuration - Django Only
export const API_ENDPOINTS = {
  // Authentication (ARGUS Auth Service - JWT)
  AUTH: {
    LOGIN: '/auth/login/',
    REFRESH: '/auth/refresh/',
    VALIDATE_TOKEN: '/auth/verify/',
    LOGOUT: '/auth/logout/'
  },

  // ===== HERMES ENDPOINTS (via /api/hermes/) =====

  // Provider Requests (Provider perspective - all incoming requests)
  PROVIDER_REQUESTS: {
    LIST: '/hermes/provider/inbox/',
    DETAIL: '/hermes/provider/inbox/{id}/',
    UPDATE: '/hermes/provider/inbox/{id}/'
  },

  // Client Orders (Client perspective - own orders)
  CLIENT_ORDERS: {
    LIST: '/hermes/client/orders/',
    DETAIL: '/hermes/client/orders/{id}/',
    CREATE: '/hermes/client/orders/',
    UPDATE: '/hermes/client/orders/{id}/',
    STATS: '/hermes/client/dashboard/stats/',
    RECENT: '/hermes/client/orders/recent/',
    CHART_DATA: '/hermes/client/dashboard/charts/'
  },

  // Legacy REQUESTS endpoint for backward compatibility
  REQUESTS: {
    LIST: '/hermes/provider/inbox/',
    DETAIL: '/hermes/provider/inbox/{id}/',
    CREATE: '/hermes/client/orders/',
    UPDATE: '/hermes/provider/inbox/{id}/',
    STATS: '/hermes/client/dashboard/stats/',
    RECENT: '/hermes/client/orders/recent/',
    CHART_DATA: '/hermes/client/dashboard/charts/'
  },

  // Provider Dashboard (Provider perspective - all requests statistics)
  PROVIDER_DASHBOARD: {
    STATS: '/hermes/provider/statistics/',
    CHARTS: '/hermes/provider/statistics/',
    RECENT: '/hermes/provider/statistics/'
  },

  // Client Dashboard (Client perspective - own orders statistics)
  CLIENT_DASHBOARD: {
    STATS: '/hermes/client/dashboard/stats/',
    CHARTS: '/hermes/client/dashboard/charts/',
    RECENT: '/hermes/client/orders/recent/'
  },

  // Legacy DASHBOARD endpoint for backward compatibility
  DASHBOARD: {
    STATS: '/hermes/provider/statistics/',
    CHARTS: '/hermes/provider/statistics/'
  },

  // Feasibility
  FEASIBILITY: {
    CHECK: '/hermes/provider/orders/{id}/feasibility/',
    COMPLETE: '/hermes/provider/orders/{id}/complete-feasibility/'
  },

  // Negotiation
  NEGOTIATION: {
    GET: '/hermes/provider/operations/negotiations/{id}/',
    UPDATE: '/hermes/provider/operations/negotiations/{id}/',
    ADD_MESSAGE: '/hermes/provider/operations/negotiations/{id}/messages/',
    ACCEPT: '/hermes/provider/operations/negotiations/{id}/accept/',
    REJECT: '/hermes/provider/operations/negotiations/{id}/reject/'
  },

  // Order Execution
  EXECUTION: {
    GET_STATUS: '/hermes/provider/operations/execution/{id}/',
    START_STEP: '/hermes/provider/operations/execution/{id}/step/'
  }
};

// Helper function to build complete URLs
export const buildApiUrl = (endpoint, params = {}) => {
  let url = `${API_BASE_URL}${endpoint}`;

  // Replace path parameters (e.g., {id} with actual values)
  Object.keys(params).forEach(key => {
    url = url.replace(`{${key}}`, params[key]);
  });

  return url;
};

// Configuration object for axios
export const API_CONFIG = {
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  withCredentials: false
};

// Debug logging
console.log('=== API Configuration Debug ===');
console.log('Environment Variables:');
console.log('- NODE_ENV:', process.env.NODE_ENV);
console.log('- REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('Computed Values:');
console.log('- isProduction:', isProduction);
console.log('- Backend: Django (Fixed)');
console.log('- API_BASE_URL:', API_BASE_URL);
console.log('- LOGIN_ENDPOINT:', API_ENDPOINTS.AUTH.LOGIN);
console.log('===============================');

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  API_CONFIG,
  buildApiUrl
};